import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';
import { GameplayHistoryModule } from '../../../../modules/support/manage-user/gameplay-history';

export const Route = createFileRoute(
  '/dashboard/support/manage-user/gameplay-history'
)({
  validateSearch: z.object({
    userId: z.string().optional(),
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <GameplayHistoryModule />;
}
